import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Action} from './send-reminder.enum';

interface SendReminderData {
    recipient_role_id: number;
    action: Action;
    phone_no: string
}

@Injectable({
    providedIn: 'root'
})
export class SendReminderService {

    constructor(private http: HttpClient) {
    }

    /**
     * get the document participants
     * @param document_id
     * @param data
     * @returns Promiss
     */
    sendReminder(document_id: number, data:SendReminderData) {
        return this.http.post(`documents/${document_id}/send-reminder`,data);
    }
}
